module.exports = __webpack_public_path__ + "static/media/Urban Colors Art_5.1857227e.jpg";